import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronLeft, FiChevronRight, FiPause, FiPlay } = FiIcons;

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const images = [
    'https://i.postimg.cc/T1PYL9zx/2026-01-23-13-13-41.jpg',
    'https://i.postimg.cc/7hLYGVFD/2026-01-23-13-13-48.jpg',
    'https://i.postimg.cc/2y58bwsz/2026-01-23-13-13-51.jpg',
    'https://i.postimg.cc/6qQ520kt/2026-01-23-13-13-53.jpg',
    'https://i.postimg.cc/90pf6GF0/IMG-7C28AD3DF068-1.jpg',
    'https://i.postimg.cc/L4BhgMkD/IMG-7C28AD3DF068-10.jpg',
    'https://i.postimg.cc/Kcr43y7Q/IMG-7C28AD3DF068-11.jpg',
    'https://i.postimg.cc/nVYM9tK0/IMG-7C28AD3DF068-12.jpg',
    'https://i.postimg.cc/SQ7jYpLg/IMG-7C28AD3DF068-13.jpg',
    'https://i.postimg.cc/T2qh5Xj7/IMG-7C28AD3DF068-14.jpg',
    'https://i.postimg.cc/05drKqGX/IMG-7C28AD3DF068-15.jpg',
    'https://i.postimg.cc/RCQqJz1b/IMG-7C28AD3DF068-16.jpg',
    'https://i.postimg.cc/L4BhgMkb/IMG-7C28AD3DF068-17.jpg',
    'https://i.postimg.cc/G3J9T1Pf/IMG-7C28AD3DF068-18.jpg',
    'https://i.postimg.cc/qBXg6dcW/IMG-7C28AD3DF068-19.jpg',
    'https://i.postimg.cc/prZdwDXp/IMG-7C28AD3DF068-2.jpg',
    'https://i.postimg.cc/7PMbJy1c/IMG-7C28AD3DF068-20.jpg',
    'https://i.postimg.cc/ZYF0vhP1/IMG-7C28AD3DF068-21.jpg',
    'https://i.postimg.cc/05drKqd1/IMG-7C28AD3DF068-22.jpg',
    'https://i.postimg.cc/kMFDRdFr/IMG-7C28AD3DF068-23.jpg',
    'https://i.postimg.cc/2jF3LfFD/IMG-7C28AD3DF068-24.jpg',
    'https://i.postimg.cc/Wp6tqP6j/IMG-7C28AD3DF068-25.jpg',
    'https://i.postimg.cc/zDS3H1S8/IMG-7C28AD3DF068-26.jpg',
    'https://i.postimg.cc/44bnHTbX/IMG-7C28AD3DF068-27.jpg',
    'https://i.postimg.cc/59qjQMq9/IMG-7C28AD3DF068-28.jpg',
    'https://i.postimg.cc/8kBsfVBp/IMG-7C28AD3DF068-29.jpg',
    'https://i.postimg.cc/qqL7P8Mt/IMG-7C28AD3DF068-3.jpg',
    'https://i.postimg.cc/59qjQMq2/IMG-7C28AD3DF068-30.jpg',
    'https://i.postimg.cc/QNkVKrkt/IMG-7C28AD3DF068-31.jpg',
    'https://i.postimg.cc/J7ctHWc0/IMG-7C28AD3DF068-32.jpg',
    'https://i.postimg.cc/TYd1rHCX/IMG-7C28AD3DF068-33.jpg',
    'https://i.postimg.cc/nrkLyvcj/IMG-7C28AD3DF068-4.jpg',
    'https://i.postimg.cc/nrkLyvcM/IMG-7C28AD3DF068-5.jpg',
    'https://i.postimg.cc/zvjfsnXR/IMG-7C28AD3DF068-6.jpg',
    'https://i.postimg.cc/MHDGCyKQ/IMG-7C28AD3DF068-7.jpg',
    'https://i.postimg.cc/x8RdwKTm/IMG-7C28AD3DF068-8.jpg',
    'https://i.postimg.cc/4y53DzNt/IMG-7C28AD3DF068-9.jpg'
  ];

  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };

  const paginate = useCallback((newDirection) => {
    setDirection(newDirection);
    setCurrentIndex((prevIndex) => (prevIndex + newDirection + images.length) % images.length);
  }, [images.length]);

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        paginate(1);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, paginate]);

  return (
    <section id="gallery" className="py-20 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Work Gallery</h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse through our portfolio of professional installations and repairs
          </p>
        </motion.div>

        {/* Main Carousel Container */}
        <div className="relative group max-w-5xl mx-auto">
          <div className="relative aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-2xl shadow-2xl bg-black">
            <AnimatePresence initial={false} custom={direction}>
              <motion.img
                key={currentIndex}
                src={images[currentIndex]}
                custom={direction}
                variants={slideVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{
                  x: { type: "spring", stiffness: 300, damping: 30 },
                  opacity: { duration: 0.2 }
                }}
                className="absolute w-full h-full object-contain md:object-cover"
                alt={`Apex Aerials Installation ${currentIndex + 1}`}
              />
            </AnimatePresence>

            {/* Overlay Navigation Controls */}
            <div className="absolute inset-0 flex items-center justify-between p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button
                onClick={() => { paginate(-1); setIsAutoPlaying(false); }}
                className="w-12 h-12 bg-white/20 hover:bg-white/40 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all shadow-lg"
              >
                <SafeIcon icon={FiChevronLeft} className="w-6 h-6" />
              </button>
              <button
                onClick={() => { paginate(1); setIsAutoPlaying(false); }}
                className="w-12 h-12 bg-white/20 hover:bg-white/40 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all shadow-lg"
              >
                <SafeIcon icon={FiChevronRight} className="w-6 h-6" />
              </button>
            </div>

            {/* Controls & Counter */}
            <div className="absolute bottom-6 left-6 flex items-center gap-4">
              <button 
                onClick={() => setIsAutoPlaying(!isAutoPlaying)}
                className="w-10 h-10 bg-black/50 hover:bg-red-600 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-colors"
              >
                <SafeIcon icon={isAutoPlaying ? FiPause : FiPlay} className="w-4 h-4" />
              </button>
              <div className="px-4 py-1 bg-black/50 backdrop-blur-md rounded-full text-white text-sm font-medium">
                {currentIndex + 1} / {images.length}
              </div>
            </div>
          </div>

          {/* Progress Bar for AutoPlay */}
          {isAutoPlaying && (
            <motion.div 
              key={currentIndex}
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{ duration: 5, ease: "linear" }}
              className="absolute bottom-0 left-0 h-1 bg-red-600"
            />
          )}
        </div>

        {/* Thumbnail Strip */}
        <div className="mt-8 max-w-5xl mx-auto">
          <div className="flex gap-3 overflow-x-auto pb-4 px-2 no-scrollbar">
            {images.map((img, index) => (
              <motion.button
                key={index}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  setDirection(index > currentIndex ? 1 : -1);
                  setCurrentIndex(index);
                  setIsAutoPlaying(false);
                }}
                className={`relative flex-shrink-0 w-24 h-16 rounded-lg overflow-hidden border-2 transition-all ${
                  currentIndex === index ? 'border-red-600 scale-110 z-10' : 'border-transparent opacity-60'
                }`}
              >
                <img src={img} className="w-full h-full object-cover" alt="thumbnail" />
              </motion.button>
            ))}
          </div>
        </div>
      </div>
      
      <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>
  );
};

export default Gallery;